import React from 'react';
import { motion } from 'framer-motion';

/**
 * Animated magnifying-glass icon: the ring gently grows on hover and pulses
 * once when `active` (e.g. input focused / search overlay opened).
 */
const SearchIcon = ({ size = 18, active = false, className = '' }) => (
  <motion.svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    initial="rest"
    animate={active ? 'active' : 'rest'}
    whileHover="hover"
  >
    <motion.circle
      cx="10.5"
      cy="10.5"
      r="6.5"
      stroke="currentColor"
      strokeWidth="1.8"
      style={{ originX: 0.5, originY: 0.5 }}
      variants={{
        rest: { scale: 1 },
        hover: { scale: 1.12 },
        active: { scale: [1, 1.22, 1], transition: { duration: 0.45, ease: 'easeInOut' } },
      }}
    />
    <motion.line
      x1="15.2"
      y1="15.2"
      x2="20"
      y2="20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      variants={{
        rest: { x2: 20, y2: 20 },
        hover: { x2: 20.6, y2: 20.6 },
        active: { x2: 20, y2: 20 },
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 15 }}
    />
  </motion.svg>
);

export default SearchIcon;